import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9af74e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-noaccess",
  role: "status"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "nge-noaccess-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "nge-noaccess" }, {
    default: _withCtx(() => [
      ($setup.shown && $setup.current)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: $setup.lockIcon,
              class: "nge-noaccess-icon",
              alt: "",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, _hoisted_2),
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode("You don't have access to "),
              _createElementVNode("b", null, _toDisplayString($setup.current.shortLabel || $setup.current.label), 1 /* TEXT */),
              _createTextVNode(" yet, so its cells won't load."),
              ($setup.needsRetinaFirst($setup.current))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Unlock Level 1 (Retina) before moving to " + _toDisplayString($setup.current.shortLabel || $setup.current.label) + ": send your edits from Ask for Edit Access in the menu.", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!$setup.needsRetinaFirst($setup.current))
              ? (_openBlock(), _createBlock($setup["RequestAccessButton"], {
                  key: 0,
                  ds: $setup.current
                }, null, 8 /* PROPS */, ["ds"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              type: "button",
              class: "nge-noaccess-x",
              title: "Close",
              "aria-label": "Close",
              onClick: $setup.close
            }, "×")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}